/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
import {
  CONTENT_TYPE_JSON,
  TOKEN_EXPIRED_MESSAGE,
} from "../../utils/apiConstants.js";
import { logger, sanitizeError } from "../../utils/logger.js";
/**
 * @fileoverview Sectors logic module.
 * Handles fetching sectors for several pages.
 * @module logic/sectors
 */

import { refreshToken, signOut } from "../../utils/common.js";

/** localStorage key for current user id */
export const LOCALSTORAGE_USER_ID_KEY = "userId";

/**
 * Fetches sectors.
 * @async
 * @param {Function} navigate - React Router navigation function
 * @returns {Promise<Array>} Array of sectors
 */
export const getSectors = async (navigate) => {
  const options = {
    method: "GET",
    headers: {
      "Content-Type": CONTENT_TYPE_JSON,
    },
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_ROOT_API}sector`,
      options,
    );
    const data = await response.json();
    if (data?.message === TOKEN_EXPIRED_MESSAGE) {
      const newTokens = await refreshToken();
      if (!newTokens) {
        await signOut();
        navigate("/");
        return [];
      }
      return getSectors(navigate);
    }
    return Array.isArray(data) ? data : [];
  } catch (error) {
    logger.error("Error", { err: sanitizeError(error) });
    return [];
  }
};
